import React from "react";
import { useTranslation } from "react-i18next";
import { StyledStepLine } from "./step-line.styled";
import icon_checked from "assets/icon_checked_password.svg";

const StepLine = (props) => {
  const { className, listStep, activeStep = 1 } = props;
  const { t } = useTranslation("translation");
  const DEFAULT_STEP_ORDER_PAYMENT = [
    { label: t("waitingStaffConfirm") },
    { label: t("pointAccrual") },
    { label: t("payment") },
  ];

  const isStepComplete = (indStep) => (indStep + 1) < Number(activeStep);

  const renderClassStatus = (indStep) => {
    if (isStepComplete(indStep)) return "step-dot--completed";
    if (indStep + 1 === Number(activeStep)) return "step-dot--active";
    return "";
  };

  return (
    <StyledStepLine className={`${className || ""} mb-2`}>
      <div className="step-line" />
      {(listStep || DEFAULT_STEP_ORDER_PAYMENT).map((step, index) => {
        return (
          <div className={`step-dot ${renderClassStatus(index)}`}>
            <div className="step-dot-icon">
              {isStepComplete(index) && <img src={icon_checked} alt="icon_checked" />}
            </div>
            <span>{step.label}</span>
          </div>
        );
      })}
    </StyledStepLine>
  );
};

export default StepLine;
